import { DialogContent, List, ListItemIcon, ListItemText, MenuItem, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { BottomDialog } from '@dhl/confirmation-dialog'
import { Barcode, QRCode } from '@dhl/icons'
import { BarcodeScannerFormatKind } from '../types'

type Props = {
  isOpen: boolean
  onClose: () => void
  onSelect: (option: BarcodeScannerFormatKind) => void
}

export const ScanOptionsDialog = ({ isOpen, onClose, onSelect }: Props) => {
  const { t } = useTranslation()

  return (
    <BottomDialog open={isOpen} onClose={onClose} data-test="scan-options">
      <DialogContent>
        <Typography variant="h6" pt={1}>
          {t('components.inputs.barcodeInput.scanOptionsDialogTitle')}
        </Typography>
        <Paper sx={{ my: 2 }}>
          <List>
            <MenuItem onClick={() => onSelect('QR')} divider data-test="QR-Code">
              <ListItemIcon>
                <QRCode />
              </ListItemIcon>
              <ListItemText primary={t('components.inputs.barcodeInput.scanQR')} />
            </MenuItem>
            <MenuItem onClick={() => onSelect('1D')} divider data-test="barcode-option">
              <ListItemIcon>
                <Barcode />
              </ListItemIcon>
              <ListItemText primary={t('components.inputs.barcodeInput.scanBarcode')} />
            </MenuItem>
          </List>
        </Paper>
      </DialogContent>
    </BottomDialog>
  )
}
